import Constants from '../submodules/logictry_config/constants';
import Version from '../version.json';

export default function checkServerVersion(apiVersion) {
  const parseVersion = (version) => version.split('.').map(Number);
  const clientSide = parseVersion(Version.version);
  const serverSide = parseVersion(apiVersion);
  if (serverSide.length === 3 && clientSide.length === 3 && (serverSide[0] !== clientSide[0] || serverSide[1] !== clientSide[1])) {
    if (!Constants.isIphone) window.location.reload();
  }
}
